/**
 * Centralized test IDs for Playwright E2E tests
 *
 * This file contains all data-testid values used throughout the application.
 * Import these constants in both components and tests to ensure consistency.
 *
 * @example
 * // In a component:
 * import { TEST_IDS } from '@/lib/test-ids';
 * <div data-testid={TEST_IDS.SAMPLE_QUESTIONS}>...</div>
 *
 * // In a test:
 * import { TEST_IDS } from '@/lib/test-ids';
 * await page.getByTestId(TEST_IDS.SAMPLE_QUESTIONS).click();
 */

export const TEST_IDS = {
  // Modal/Dialog
  CLOSE_MODAL_BUTTON: 'close-modal-button',

  // Chat Interface
  MULTIMODAL_INPUT: 'multimodal-input',
  SEND_BUTTON: 'send-button',
  STOP_BUTTON: 'stop-button',
  SCROLL_TO_BOTTOM_BUTTON: 'scroll-to-bottom-button',

  // Messages
  MESSAGE_USER: 'message-user',
  MESSAGE_ASSISTANT: 'message-assistant',
  MESSAGE_CONTENT: 'message-content',
  MESSAGE_REASONING: 'message-reasoning',
  MESSAGE_REASONING_TOGGLE: 'message-reasoning-toggle',
  MESSAGE_UPVOTE: 'message-upvote',
  MESSAGE_DOWNVOTE: 'message-downvote',
  MESSAGE_ATTACHMENTS: 'message-attachments',
  MESSAGE_EDIT_BUTTON: 'message-edit-button',
  MESSAGE_EDITOR: 'message-editor',
  MESSAGE_EDITOR_SEND_BUTTON: 'message-editor-send-button',

  // Questions/Suggestions
  SAMPLE_QUESTIONS: 'sample-questions',
  SUGGESTED_FOLLOW_UPS: 'suggested-follow-ups',

  // Sidebar
  SIDEBAR_TOGGLE_BUTTON: 'sidebar-toggle-button',

  // Model/Visibility Selectors
  MODEL_SELECTOR: 'model-selector',
  VISIBILITY_SELECTOR: 'visibility-selector',

  // Attachments
  ATTACHMENTS_BUTTON: 'attachments-button',

  // Toast Notifications
  TOAST: 'toast',
} as const;

// Type for autocomplete and type safety
export type TestId = typeof TEST_IDS[keyof typeof TEST_IDS];
